import { IoCheckmarkOutline  } from "react-icons/io5";
import DonutYears from "./DonutYears";

const ListSkills = ({ items, isIcon, layout }) => {
  return (
    <ul className={!layout ? 'skill-list' : layout }>
      {items.map((item, index) => (
        (!isIcon) ?
          <li key={index}><DonutYears years={item.years} /><span className={item.title.length > 15 ? "long-title" : "short-title"}>{item.title}</span></li> : 
          <li key={index}><IoCheckmarkOutline className="list-icon" /><span>{item.title}</span></li>
      ))}
    </ul>
  );
};

export default ListSkills;